import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                nav: 'toggleNav',
                search: 'toggleSearch',
                close: 'close',
                accessibilite: 'toggleAccessibilite',
            }
        }
    }

    init() {

    }

    toggleNav(e) {
        const html = document.querySelector('html');
        if(html.classList.contains('has-navOpen')) {
            html.classList.remove('has-navOpen');
            $('.c-nav').css('height', '0px');
            $('.c-header_wrap').css('height', $('.c-header_head').outerHeight() + 'px');
        } else {
            html.classList.add('has-navOpen');
            let nav_height = $('.c-nav_wrap').outerHeight();
            $('.c-nav').css('height', nav_height+'px');
            $('.c-header_wrap').css('height', nav_height+'px');
        }
    }

    close() {
        const html = document.querySelector('html');
        html.classList.remove('has-navOpen');
        $('.c-nav').css('height', '0px');
        $('.c-header_wrap').css('height', $('.c-header_head').outerHeight() + 'px');
    }

    toggleAccessibilite(){
        if (document.getElementById('pojo-a11y-toolbar').classList.contains('pojo-a11y-toolbar-open')){
            document.getElementById('pojo-a11y-toolbar').classList.remove('pojo-a11y-toolbar-open');
        } else{
            document.getElementById('pojo-a11y-toolbar').classList.add('pojo-a11y-toolbar-open');
        }
    }
}
